export * from './activeVariantsMap'
export * from './viewerManagerStructureApi'
export * from './viewerManagerDataApi'
export * from './beckyPropsInitialStore'
export * from './builderPropsRuntimeOverridesStore'
export * from './platform'
export * from './layoutDone'
export * from './languageChangeHandler'
export * from './appSpecUpdatedHandler'
export * from './manifest'
export * from './editorVsmExperiments'

export const RuntimeApiSymbol = Symbol('RuntimeApi')
export const ViewerManagerRuntimeApiSymbol = Symbol('ViewerManagerRuntimeApi')
export interface IViewerManagerRuntimeActiveVariantsApi {
	runtime: {
		setActiveVariants: (pathOrCompId: string | string[], variantIds: string[]) => void
		getActiveVariants: (pathOrCompId: string | string[]) => string[]
		resetActiveVariants: (pathOrCompId?: string | string[], variantIds?: string[]) => void
		clearActiveVariants: () => void
	}
}
export const CarmiInstance = Symbol('CarmiInstance')
export const isViewerFragmentSymbol = Symbol('isViewerFragment')
export const DataRequirementsCheckerSymbol = Symbol('DataRequirementsChecker')
export const PagesModelsRegistrarSymbol = Symbol('PagesModelsRegistrar')
export const TBInstanceIdSymbol = Symbol('tbInstanceId')
export const EditorVsmApiSymbol = Symbol('EditorVsmApi')
export const VsmPageConfigsFactoriesSymbol = Symbol('VsmPageConfigsFactories')
export const MarkBuilderComponentsAsDeadHandlerSymbol = Symbol('MarkBuilderComponentsAsDeadHandler')
export const VsmMasterPageConfigsFactoriesSymbol = Symbol('VsmMasterPageConfigsFactories')
// Editor VSM aggregation maps (explicit per-feature editor entries; bound under the `vsm_editor` gate).
export const EditorSiteConfigsFactoriesSymbol = Symbol('EditorSiteConfigsFactories')
export const EditorOnlyConfigsFactoriesSymbol = Symbol('EditorOnlyConfigsFactories')
export const EditorSideEffectsFactoriesSymbol = Symbol('EditorSideEffectsFactories')
